import App from './components/App.svelte';
import { router } from './libs/router';
import './data/sprints';

(window as any).stopRouter = router.listen();

document.body.innerHTML = '';

const app = new App({
	target: document.body,
});

export default app;
